<template>
  <div class="home">
    <HeaderBar :title="title"></HeaderBar>
    <div class="center-box">
      <div>
        <div class="user-box" v-show="false">
          <div class="content-box1">
            <div class="user-box-username">{{ userForm.userName }}</div>
            <div class="user-box-secname">{{ userForm.trueName }}</div>
            <div class="user-box-photo">
              <van-image round class="user-photo" :src="avatar" color="#1989fa" />
            </div>
          </div>
        </div>
        <van-grid :column-num="3" :border="false" v-show="false">
          <van-grid-item>
            <div class="user-data-border">
              <div class="user-data-title">数据展示</div>
              <div class="user-data-number">321</div>
            </div>
          </van-grid-item>
          <van-grid-item>
            <div class="user-data-border">
              <div class="user-data-title">数据展示</div>
              <div class="user-data-number">321</div>
            </div>
          </van-grid-item>
          <van-grid-item>
            <div class="user-data-noborder">
              <div class="user-data-title">数据展示</div>
              <div class="user-data-number">321</div>
            </div>
          </van-grid-item>
        </van-grid>
        <!-- <div class="user-box">
          <div class="content-box">
            <van-image class="user-photo" :src="avatar" color="#1989fa" />
            <div class="user">{{ userForm.TrueName }}</div>
          </div>
        </div> -->
        <div class="user-box">
          <div class="content-box">
            <div class="user-box-left">
              <div class="user-box-left-top">
                <div class="user-box-companyname">{{ userForm.HosName }}</div>
                <div class="user-box-specname">{{ userForm.SecName }}</div>
              </div>
              <div class="user-box-left-bottom">
                <span class="user-box-realname" style="font-size: 1rem;">{{ userForm.TrueName }}</span><br>
                <span class="user-box-realname" style="font-size: 1rem;"> {{ userForm.Tel }}</span>
              </div>
            </div>
            <div class="user-box-right">
              <van-image class="user-photo" :src="avatar" color="#1989fa" />
            </div>
          </div>
        </div>
        <van-cell-group>
          <!-- <FormNormalInput label="姓名" v-model="userForm.TrueName " readonly /> -->
          <!-- <FormNormalInput label="手机号" v-model="userForm.tel " readonly /> -->
          <!-- <FormNormalInput label="当前角色" v-model="userForm.CurRole " readonly /> -->
          <!-- <FormNormalInput label="单位" v-model="userForm.HosName " readonly />
          <FormNormalInput label="科室" v-model="userForm.SecName " readonly /> -->
          <FormNormalInput label="身份证" v-model="userForm.CardId"  />
          <FormNormalInput label="开户行" v-model="userForm.Email"  />
          <FormNormalInput label="银行账号" v-model="userForm.Remarks"  />

        </van-cell-group>
        <div style="height: 0.5rem;"></div>
        <van-cell-group>
          <van-field label="我的资料" left-icon="setting" is-link readonly @click="Info()" v-show="false" />
        </van-cell-group>

        <div style="margin: 16px;">
          <van-button block type="info" @click="Exit" v-show="false">退出绑定</van-button>
          <van-button block type="info" @click="UpdateInfo">修改信息</van-button>
        </div>
      </div>
    </div>
    <FooterBar></FooterBar>
  </div>
</template>

<script>
export default {
  name: 'Workbench',
  data() {
    return {
      title: '我的',
      avatar: require('../../assets/image/icon/user.jpg'),
      exitUrl: this.$utils.Url.system + "/api/APISEMP_User/UnbindOpenId",
      userForm: ''
    }
  },

  methods: {
    Info: function () {
      this.$dialog({
        message: "功能待开发"
      })
      // this.$router.push({
      //   name: 'UserInfo'
      // })
    },
    Exit: function () {
      let that = this
      that.$dialog.confirm({
        title: '警告',
        message: '确认退出当前绑定吗?',
      })
        .then(() => {
          // var params = {
          //   id: that.userModel.UserID,
          // }
          // that.$utils.HttpPost(that.exitUrl, params, function() {

          //   that.$dialog({
          //     message: "已解除绑定,请重新登录"
          //   })
          //   that.$router.push("Login")
          // }, function(data) {
          //   that.$dialog({
          //     message: data.Error
          //   })
          // }, null)
          that.$router.push("Login")
        })
        .catch(() => {

        });
    },
    UpdateInfo: function () {
      var that = this
      // if (that.userForm.CardId == '' || that.userForm.Email == '' || that.userForm.Remarks == '') {
      //   this.$dialog({
      //     message: '请填全所有信息',
      //   });
      //   return
      // }
      that.$utils.HttpPost(this.$utils.Url.system + '/api/APISEMP_User/UpdateUserSingle', that.userForm, function () {
        that.$dialog({
          message: '修改成功',
        });
        that.userForm.cardId = that.userForm.CardId
        that.userForm.email = that.userForm.Email
        that.userForm.remarks = that.userForm.Remarks
        sessionStorage.setItem("userInfo", JSON.stringify(that.userForm));
      }, null, null, null)
    }
  },
  mounted() {
    this.userForm = this.$utils.clone(JSON.parse(sessionStorage.getItem("userInfo")))
    this.$utils.getAccessToken()

  }
}
</script>
<style scoped>
.user-box {
  width: 100%;
  height: 180px;
  padding: 20px 15px;
  box-sizing: border-box;
}

.user-box .content-box {
  background-color: #fff;
  width: 100%;
  height: 100%;
  border-radius: 4px;
  border: 1px solid #ebeef5;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
  display: flex;
}

.user-box-left {
  flex: 1;
  padding: 15px 0 20px 25px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.user-box-companyname {
  color: #666;
}

.user-box-specname {
  color: #999;
  font-size: 14px;
}

.user-box-realname {
  color: #333;
  font-family: mediumBlodFont;
  font-size: 18px;
}

.user-box-right {
  padding: 10px;
  width: 90px;
  /* height: 90%; */
  min-width: 90px;
}

.user-box .user-photo {
  width: 80px;
  height: 80px;
  margin-top: 15px;
}

.user-box .content-box1 {
  width: 100%;
  height: 100%;
  border-radius: 8px;
  background-image: linear-gradient(135deg, #2378FF 0%, #7D6BFF 100%);
  display: flex;
  flex-direction: column;
}

.user-box-username {
  width: 100%;
  font-size: 16px;
  color: #FFFFFF;
  text-align: center;
  line-height: 20px;
  font-weight: 600;
  height: 20px;
  margin-top: 20px;
}

.user-box-secname {
  width: 100%;
  font-size: 12px;
  color: #FFFFFF;
  text-align: center;
  line-height: 20px;
  font-weight: 600;
  height: 20px;
}

.user-box-photo {
  width: 100%;
  text-align: center;
}

.van-image__img {
  opacity: 1;
}

.user-data-border {
  width: 100%;
  border-right: 1PX solid #DDDDDD;
  text-align: center;
}

.user-data-noborder {
  width: 100%;
  text-align: center;
}

.user-data-title {
  font-size: 12px;
  color: #999999;
  text-align: center;
  line-height: 12px;
  font-weight: 400;

}

.user-data-number {
  font-size: 18px;
  color: #000000;
  text-align: center;
  line-height: 18px;
  font-weight: 600;
  margin-top: 10px;
}
</style>
